export default "__VITE_ASSET__C40hIf8t__"